const faqGroups = [
  ['.bc-faq-q', '.bc-faq-a'],
  ['.cs-faq-q', '.cs-faq-a'],
  ['.sb-faq-q', '.sb-faq-a'],
];

for (const [buttonSelector, answerSelector] of faqGroups) {
  const buttons = [...document.querySelectorAll(buttonSelector)];
  if (buttons.length === 0) continue;

  const syncState = () => {
    for (const button of buttons) {
      const answer = button.nextElementSibling;
      if (!(answer instanceof HTMLElement) || !answer.matches(answerSelector)) continue;

      const isOpen = answer.classList.contains('open');
      button.setAttribute('aria-expanded', String(isOpen));
      answer.hidden = !isOpen;
    }
  };

  buttons.forEach((button, index) => {
    const answer = button.nextElementSibling;
    if (!(answer instanceof HTMLElement) || !answer.matches(answerSelector)) return;

    const answerId = answer.id || `SeoFaqAnswer-${buttonSelector.slice(1)}-${index + 1}`;
    answer.id = answerId;
    button.setAttribute('aria-controls', answerId);
    button.setAttribute('aria-expanded', 'false');
    button.querySelector('[class$="faq-icon"]')?.setAttribute('aria-hidden', 'true');
    answer.hidden = true;

    button.addEventListener('click', () => queueMicrotask(syncState));
  });
}
